module.exports = __webpack_public_path__ + "img/kibanacosmos.815feb60.jpg";